import { useState } from 'react'

const CalculatorApp = () => {
  const [display, setDisplay] = useState('0')
  const [previousValue, setPreviousValue] = useState(null)
  const [operation, setOperation] = useState(null)
  const [waitingForOperand, setWaitingForOperand] = useState(false)

  const inputNumber = (num) => {
    if (waitingForOperand) {
      setDisplay(String(num))
      setWaitingForOperand(false)
    } else {
      setDisplay(display === '0' ? String(num) : display + num)
    }
  }

  const inputOperator = (nextOperation) => {
    const inputValue = parseFloat(display)

    if (previousValue === null) {
      setPreviousValue(inputValue)
    } else if (operation) {
      const currentValue = previousValue || 0
      const newValue = calculate(currentValue, inputValue, operation)

      setDisplay(String(newValue))
      setPreviousValue(newValue)
    }

    setWaitingForOperand(true)
    setOperation(nextOperation)
  }

  const calculate = (firstValue, secondValue, operation) => {
    switch (operation) {
      case '+':
        return firstValue + secondValue
      case '-':
        return firstValue - secondValue
      case '×':
        return firstValue * secondValue
      case '÷':
        return firstValue / secondValue
      case '=':
        return secondValue
      default:
        return secondValue
    }
  }

  const performCalculation = () => {
    const inputValue = parseFloat(display)

    if (previousValue !== null && operation) {
      const newValue = calculate(previousValue, inputValue, operation)
      setDisplay(String(newValue))
      setPreviousValue(null)
      setOperation(null)
      setWaitingForOperand(true)
    }
  }

  const clearAll = () => {
    setDisplay('0')
    setPreviousValue(null)
    setOperation(null)
    setWaitingForOperand(false)
  }

  const clearEntry = () => {
    setDisplay('0')
  }

  const inputDecimal = () => {
    if (waitingForOperand) {
      setDisplay('0.')
      setWaitingForOperand(false)
    } else if (display.indexOf('.') === -1) {
      setDisplay(display + '.')
    }
  }

  const Button = ({ onClick, className = "", children, ...props }) => (
    <button
      className={`h-12 rounded-lg font-semibold transition-all duration-150 active:scale-95 ${
        className
      }`}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  )

  return (
    <div className="w-80 mx-auto bg-gray-800 rounded-xl p-4">
      {/* Display */}
      <div className="bg-gray-900 rounded-lg p-4 mb-4">
        <div className="text-right text-3xl font-mono text-white min-h-[40px] flex items-center justify-end overflow-hidden">
          {display}
        </div>
      </div>

      {/* Buttons */}
      <div className="grid grid-cols-4 gap-2">
        {/* Row 1 */}
        <Button
          onClick={clearAll}
          className="bg-red-600 hover:bg-red-700 text-white col-span-2"
        >
          AC
        </Button>
        <Button
          onClick={clearEntry}
          className="bg-orange-600 hover:bg-orange-700 text-white"
        >
          CE
        </Button>
        <Button
          onClick={() => inputOperator('÷')}
          className="bg-blue-600 hover:bg-blue-700 text-white"
        >
          ÷
        </Button>

        {/* Row 2 */}
        <Button
          onClick={() => inputNumber(7)}
          className="bg-gray-600 hover:bg-gray-700 text-white"
        >
          7
        </Button>
        <Button
          onClick={() => inputNumber(8)}
          className="bg-gray-600 hover:bg-gray-700 text-white"
        >
          8
        </Button>
        <Button
          onClick={() => inputNumber(9)}
          className="bg-gray-600 hover:bg-gray-700 text-white"
        >
          9
        </Button>
        <Button
          onClick={() => inputOperator('×')}
          className="bg-blue-600 hover:bg-blue-700 text-white"
        >
          ×
        </Button>

        {/* Row 3 */}
        <Button
          onClick={() => inputNumber(4)}
          className="bg-gray-600 hover:bg-gray-700 text-white"
        >
          4
        </Button>
        <Button
          onClick={() => inputNumber(5)}
          className="bg-gray-600 hover:bg-gray-700 text-white"
        >
          5
        </Button>
        <Button
          onClick={() => inputNumber(6)}
          className="bg-gray-600 hover:bg-gray-700 text-white"
        >
          6
        </Button>
        <Button
          onClick={() => inputOperator('-')}
          className="bg-blue-600 hover:bg-blue-700 text-white"
        >
          −
        </Button>

        {/* Row 4 */}
        <Button
          onClick={() => inputNumber(1)}
          className="bg-gray-600 hover:bg-gray-700 text-white"
        >
          1
        </Button>
        <Button
          onClick={() => inputNumber(2)}
          className="bg-gray-600 hover:bg-gray-700 text-white"
        >
          2
        </Button>
        <Button
          onClick={() => inputNumber(3)}
          className="bg-gray-600 hover:bg-gray-700 text-white"
        >
          3
        </Button>
        <Button
          onClick={() => inputOperator('+')}
          className="bg-blue-600 hover:bg-blue-700 text-white"
        >
          +
        </Button>

        {/* Row 5 */}
        <Button
          onClick={() => inputNumber(0)}
          className="bg-gray-600 hover:bg-gray-700 text-white col-span-2"
        >
          0
        </Button>
        <Button
          onClick={inputDecimal}
          className="bg-gray-600 hover:bg-gray-700 text-white"
        >
          .
        </Button>
        <Button
          onClick={performCalculation}
          className="bg-green-600 hover:bg-green-700 text-white"
        >
          =
        </Button>
      </div>
    </div>
  )
}

export default CalculatorApp